<script>
   /**************************************************************/
   /* Svelte component for ExtremePlot settings                  */
   /**************************************************************/

   import Container from '../../../shared/controls/Container.svelte';

   export let params;
   export let res;

   $: params = {};
</script>

{#if res  }
<Container label="">
   <p class="title">Selectivity plot (integral)</p>
</Container>
{/if}
